import React from 'react';
import { AcademicCapIcon, CalendarIcon, ClipboardIcon, UserGroupIcon, CurrencyRupeeIcon, ChatBubbleBottomCenterTextIcon, TruckIcon ,  ChartBarIcon,
  CalendarDaysIcon,
  ClipboardDocumentListIcon,
  DocumentTextIcon,
  BellIcon,
  PencilSquareIcon,
  ClipboardDocumentCheckIcon, // for Assignment Management
  ExclamationCircleIcon,      // for Complaint Management
  DocumentIcon,               // for Document Management
  BookOpenIcon ,
  UsersIcon,} from '@heroicons/react/24/outline';

const features = [
  { title: 'AI-Driven Admission & Registration', icon: <UserGroupIcon className="h-8 w-8 text-indigo-500" /> },
  { title: 'Personalized Dashboards', icon: <AcademicCapIcon className="h-8 w-8 text-indigo-500" /> },
  { title: 'Smart Attendance System & Management', icon: <CalendarIcon className="h-8 w-8 text-indigo-500" /> },
  { title: 'Assignment Management', icon: < ClipboardDocumentCheckIcon className="h-8 w-8 text-indigo-500" /> },
  { title: 'AI-Powered Quiz Generation', icon: <PencilSquareIcon className="h-8 w-8 text-indigo-500" /> },
  { title: 'Salary and Finance Management', icon: <CurrencyRupeeIcon className="h-8 w-8 text-indigo-500" /> },
  { title: 'Complaint Management', icon: <ExclamationCircleIcon className="h-8 w-8 text-indigo-500" /> },
  { title: 'Real-Time Bus Tracking', icon: <TruckIcon className="h-8 w-8 text-indigo-500" /> },
  { title: 'Timetable & Notice Management', icon: <CalendarIcon className="h-8 w-8 text-indigo-500" /> },
  // { title: 'AI-based Attendance', icon: <UserGroupIcon className="h-8 w-8 text-indigo-500" /> },
  { title: 'Report Cards & Analytics', icon: <ClipboardIcon className="h-8 w-8 text-indigo-500" /> },
  { title: 'AI-Based Answer Sheet Evaluation', icon: <AcademicCapIcon className="h-8 w-8 text-indigo-500" /> },
  { title: 'Parent-Teachers Communication', icon: <ChatBubbleBottomCenterTextIcon className="h-8 w-8 text-indigo-500" /> },
  { title: 'Student-Teachers Communication', icon: <ChatBubbleBottomCenterTextIcon className="h-8 w-8 text-indigo-500" /> },
  { title: 'Library Management', icon: <BookOpenIcon className="h-8 w-8 text-indigo-500" /> },
  
  // { title: 'Staff Directory', icon: <UserGroupIcon className="h-8 w-8 text-indigo-500" /> },
  { title: 'Document Management', icon: <DocumentIcon className="h-8 w-8 text-indigo-500" /> },
  { title: 'Notification System', icon: <BellIcon className="h-8 w-8 text-indigo-500" /> },
  { title: 'Leave Request Management', icon: <CalendarDaysIcon className="h-8 w-8 text-indigo-500" /> },
  { title: 'AI-Powered Performance Insights', icon: <ChartBarIcon className="h-8 w-8 text-indigo-500" /> },
  { title: 'AI Chatbot Assistant (Chatfires)', icon: <ChatBubbleBottomCenterTextIcon className="h-8 w-8 text-indigo-500" /> },
  { title: 'Lunch Box Analysis', icon: <ClipboardDocumentListIcon className="h-8 w-8 text-indigo-500" /> },
  { title: 'AI-Powered Lecture Summarization', icon: <DocumentTextIcon className="h-8 w-8 text-indigo-500" /> },
  { title: 'Class Behavior Analysis', icon: <UsersIcon className="h-8 w-8 text-indigo-500" /> },
 

];

const FeaturesGrid = () => {
  return (
    <section className=" py-20 px-6 md:px-16 text-white">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white">Discover What We Offer</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-slate-800 hover:bg-slate-700 border border-slate-600 rounded-lg p-6 shadow-md transition-all duration-300 hover:shadow-xl"
            >
              <div className="flex items-center gap-4 mb-3">
                {feature.icon}
                <h3 className="text-lg font-semibold">{feature.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesGrid;
